import React, {useState} from 'react'
import { Container, Row, Col,  Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem, } from 'reactstrap'

    import { Link,useLocation   } from "react-router-dom";
import Logo from '../assets/images/Agilus---Logo.png'
import velLogo from '../assets/images/velocis_logo.png'

import ScrollToTop from "react-scroll-to-top";
import NCLogo from '../assets/images/VNC Logo.png'
import BullsEyeLogo from '../assets/images/beyelogo.png'
import TheObserLogo from '../assets/images/Observer Logo.png'
import vAutomateLogo from '../assets/images/vAutomate Logo.png'
import aboutUpLogo from '../assets/images/Hover Thumnail/About-Us-Thumbnail.png'
import meetExpert from '../assets/images/Hover Thumnail/Leadership-Thumbnail.png'
import broThumbnail from '../assets/images/Hover Thumnail/Brochure-Thumbnail.png'
import caseStudy from '../assets/images/Hover Thumnail/Case-Study-Thumbnail.png'

 
 
export default function Header(props) {
 
    const [openSideBar, setOpenSideBar] = useState(false)
 
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [dropdownOpenCompany, setDropdownOpenCompany] = useState(false);
//   const toggle = () => setDropdownOpen((prevState) => !prevState);
//   const toggleCompany = () => setDropdownOpenCompany((prevState) => !prevState);
const [plateFormText, setPlateFormText] = useState('Automated Compliance, Enforcing Best Practices, Ensuring Standardization')
const [solutionText, setSolutionText] = useState('SVA')
const [companyText, setCompanyText] = useState('Empowering businesses with transformative IT Infrastructure Management')
const [resourcesText, setResourcesText] = useState(" Explore our resources for brochures, datasheets, and detailed insights")
const [companyLogo, setCompanyLogo] = useState(NCLogo)
const [companySubLogo, setCompanySubLogo] = useState(aboutUpLogo)
const [resourceSubLogo, setResourceSubLogo] = useState(broThumbnail)
    const location = useLocation();

  const isQueryForm = location.pathname === "/query-form";
    const handleSideBar=()=>{
        setOpenSideBar(!openSideBar)
        setOpenPlatformSubMenu(false)
        setOpenSolutionsSubMenu(false)
        setOpenCompanySubMenu(false)
    }
 

    const handleClickClose=()=>{
        setOpenSideBar(!openSideBar)
    }
 
    const onHoverPlatform=(e, type)=>{
        if(type=== 'CE'){
            setPlateFormText('Automated Compliance, Enforcing Best Practices, Ensuring Standardization')
            setCompanyLogo(NCLogo)
        }else if(type === 'BE'){
            setPlateFormText('Empowering IT Teams with RCA Analytics: Visualizing KPI Breaches for a Seamless User Experience')
            setCompanyLogo(BullsEyeLogo)
        }else if(type === 'TO'){
            setPlateFormText('All-in-One Dashboard: Gain high-level network insights, comprehensive visibility, and make strategic, data-driven decisions')
            setCompanyLogo(TheObserLogo)
        } else {
            setPlateFormText('Streamlines network operations, standardizes configurations, reduces manual errors, and enhances reliability')
            setCompanyLogo(vAutomateLogo)
        }
       
    }
    const onHoverSolution=(e, type)=>{
        if(type=== 'SVA'){
            setSolutionText('SVA')
        }else if(type === 'SNC'){
            setSolutionText('SNC')
        }else if(type === 'SA'){
            setSolutionText('SA')
        } else {
            setSolutionText('SIA')
        }
       
    }
    const onHoverCompany=(e, type)=>{
        if(type=== 'CAU'){
            setCompanyText('Empowering businesses with transformative IT Infrastructure Management')
            setCompanySubLogo(aboutUpLogo)
        } else {
            setCompanyText("Meet our visionary leaders driving innovations")
            setCompanySubLogo(meetExpert)  
        }
       
    }
    const onHoverResources=(e, type)=>{
        if(type=== 'Brochure'){
            setResourcesText('Explore our resources for brochures, datasheets, and detailed insights')

            setResourceSubLogo(broThumbnail)
        } else {
            setResourcesText("Explore our success stories to see how we've delivered innovative solutions, and created lasting value for our clients")
            setResourceSubLogo(caseStudy)
        }
       
    }
 
    const [openPlatformSubMenu, setOpenPlatformSubMenu] = useState(false)
    const [openSolutionsSubMenu, setOpenSolutionsSubMenu] = useState(false)
    const [openCompanySubMenu, setOpenCompanySubMenu] = useState(false)
 
    const handleSubMenu=(type)=>{
        
        if(type === 'Platforms'){
            document.getElementById('platformSubMenu').classList.add('active')
            document.getElementById('solutionSubMenu').classList.remove('active')
            document.getElementById('companySubMenu').classList.remove('active')
            setOpenPlatformSubMenu(true)
            setOpenSolutionsSubMenu(false)
            setOpenCompanySubMenu(false)
        } else if(type === 'Solutions'){
            document.getElementById('platformSubMenu').classList.remove('active')
            document.getElementById('solutionSubMenu').classList.add('active')
            document.getElementById('companySubMenu').classList.remove('active')
            setOpenSolutionsSubMenu(true)
            setOpenPlatformSubMenu(false)
            setOpenCompanySubMenu(false)
        } else if(type === 'Company'){
            document.getElementById('platformSubMenu').classList.remove('active')
            document.getElementById('solutionSubMenu').classList.remove('active')
            document.getElementById('companySubMenu').classList.add('active')
            setOpenCompanySubMenu(true)
            setOpenSolutionsSubMenu(false)
            setOpenPlatformSubMenu(false)
        }
    }

    
    

    if(window.location.pathname === '/downloadfile'){
        return null
    } else {
        return (
            <>
                 
                     <div className='header-container'>
                 <header>
                  {console.log(isQueryForm,"bvbvbv")
                  }
                       <Row>
                           <Col sm={3} className='col-6'>
                         <>
      {isQueryForm ? (
        <div className="logo">
          <Link to="/">
            <img src={velLogo} className="w-60 mt-2" />
          </Link>
        </div>
      ) : (
        <div className="logo">
          <Link to="/">
            <img src={Logo} className="w-60 mt-2" />
          </Link>
        </div>
      )}
    </>
                           </Col>
                           <Col sm={9} className='col-6 inter-regular font-14'>
                              
          
                                   {/* <nav className='menu-block'>
                                       <ul>
                                           <li>
                                               <Link to="/">Home</Link>
                                           </li>
                                           <li>
                                               <ul class="menu ps-0">
                                                   <li>
                                                       <a href="#">Platforms <i class="ms-2 arrow down" style={{ marginTop: '-5px' }}></i></a>
          
                                                       <ul>
                                                           <li><Link to="/compliance-engine">Network Compliance Platform</Link></li>
                                                           <li><Link to="/bullseye">BullsEye</Link></li>
                                                           <li><Link to="/observer">The Observer</Link></li>
                                                           <li><Link to="/vAutomate">vAutomate</Link></li>
                                                       </ul>
                                                   </li>
                                               </ul>
                                           </li>
                                           <li>
                                               <Link to="/">Solutions</Link>
                                           </li>
                                           <li>
                                               <Link to="/">Resources</Link>
                                           </li>
                                           <li>
                                              
                                               <ul class="menu ps-0">
                                                   <li>
                                                       <a href="#">Company <i class="ms-2 arrow down" style={{ marginTop: '-4px' }}></i></a>
          
                                                       <ul>
                                                           <li><Link to="/about">About Us</Link></li>
                                                           <li><Link to="/meet-expert">Meet Our Expert</Link></li>
                                                       </ul>
                                                   </li>
                                               </ul>
                                              
                                           </li>
                                           <li>
                                               <Link to="/contact">Contacts</Link>
                                           </li>
                                       </ul>
                                   </nav> */}
          
                                   <nav className='menubar-block'>
                                     <ul>
                                         <li className='mt-2' onClick={handleSideBar}>
          
                                             {
                                                 openSideBar ?
                                                 <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                                 <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                                                 </svg>:
                                                 <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
                                                 <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                                                 </svg>
                                             }
                                            
                                         </li>
                                     </ul>
                                   </nav>
          
                                   <nav class="navbar navbar-expand-lg" style={{padding: 0}}>
                                       <div class="container-fluid">
                                        
          
          
                                           <div class="collapse navbar-collapse" id="navbarExampleOnHover">
                                               <ul class="navbar-nav me-auto ps-lg-0" style={{display: 'flex',
             justifyContent: 'end'}}>
                                                   <li class="nav-item">
                                                       <Link to='/' className="nav-link">Home</Link>
                                                   </li>
                                                   <li class="nav-item dropdown dropdown-hover position-static">
                                                       <Link to='/' className="nav-link dropdown-toggle">Platforms <i class="ms-2 arrow down" style={{ marginTop: '-4px' }}></i></Link>
                                                       <div class="dropdown-menu w-100 mt-0" aria-labelledby="navbarDropdown" >
                                  
          
                                                           <div class="container">
                                                               <div class="row my-4">
                                                                   <div class="col-md-6 col-lg-4 mb-3 mb-lg-0">
                                                                       <div class="list-group list-group-flush">
                                                                           <Link className="list-group-item list-group-item-action" onMouseEnter={(e)=>onHoverPlatform(e, 'CE')} to="/compliance-engine">Network Compliance Platform</Link>
                                                                             <Link className="list-group-item list-group-item-action" onMouseEnter={(e)=>onHoverPlatform(e, 'BE')}  to="/bullseye">BullsEye</Link>
                                                                             <Link className="list-group-item list-group-item-action" onMouseEnter={(e)=>onHoverPlatform(e, 'TO')}  to="/observer">The Observer</Link>
                                                                             <Link className="list-group-item list-group-item-action"  onMouseEnter={(e)=>onHoverPlatform(e, 'VA')} to="/vAutomate">vAutomate</Link>
                                                                       </div>
                                                                   </div>
                                                                  
          
                                                                   <div class="col-md-6 col-lg-8 mb-3 mb-lg-0">
                                                                       <div>
                                                                         <h4 className='mb-4'>{plateFormText}</h4 >
                                                                         <img src={companyLogo} className='w-25' />
                                                                       </div>
                                                                   </div>
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </li>
                                                    
                                                   {/* <li class="nav-item dropdown dropdown-hover position-static">
                                                       <Link class="nav-link dropdown-toggle" to='/' >
                                                           Solution <i class="ms-2 arrow down" style={{ marginTop: '-4px' }}></i>
                                                       </Link>
                                                       <div class="dropdown-menu w-100 mt-0" aria-labelledby="navbarDropdown" >
                                  
          
                                                           <div class="container">
                                                               <div class="row my-4">
                                                                   <div class="col-md-6 col-lg-4 mb-3 mb-lg-0">
                                                                       <div class="list-group list-group-flush">
          
                                                                           <Link className="list-group-item list-group-item-action" onMouseEnter={(e)=>onHoverSolution(e, 'SVA')} to="/about">Visibility & Assurance</Link>
                                                                             <Link className="list-group-item list-group-item-action" onMouseEnter={(e)=>onHoverSolution(e, 'SNC')} to="/meet-expert">Network Compliance</Link>
                                                                             <Link className="list-group-item list-group-item-action" onMouseEnter={(e)=>onHoverSolution(e, 'SA')} to="/meet-expert">Analytics</Link>
                                                                             <Link className="list-group-item list-group-item-action" onMouseEnter={(e)=>onHoverSolution(e, 'SIA')} to="/meet-expert">ITOPs Automation</Link>
                                                                       </div>
                                                                   </div>
                                                                   <div class="col-md-6 col-lg-8 mb-3 mb-lg-0">
                                                                       <div>
                                                                             <h2>{solutionText}</h2>
                                                                            
                                                                       </div>
                                                                   </div>
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </li> */}
          
                                                   <li>
                                                       <Link to="/services" className="nav-link">Services</Link>
                                                   </li>
                                                 
          
                                                     <li class="nav-item dropdown dropdown-hover position-static">
                                                       <Link class="nav-link dropdown-toggle" to='/' >
                                                           Resources <i class="ms-2 arrow down" style={{ marginTop: '-4px' }}></i>
                                                       </Link>
                                                       <div class="dropdown-menu w-100 mt-0" aria-labelledby="navbarDropdown" >
                                  
          
                                                           <div class="container">
                                                               <div class="row my-4">
                                                                   <div class="col-md-6 col-lg-4 mb-3 mb-lg-0">
                                                                       <div class="list-group list-group-flush">
          
                                                                           <Link className="list-group-item list-group-item-action" onMouseEnter={(e)=> onHoverResources(e, 'Brochure')} to="/brochure">Brochures & Data Sheets</Link>
                                                                             <Link className="list-group-item list-group-item-action" onMouseEnter={(e)=> onHoverResources(e, 'Casestudy')} to="/successstories">Success Stories</Link>
                                                                       </div>
                                                                   </div>
                                                                   <div class="col-md-6 col-lg-8 mb-3 mb-lg-0">
                                                                       <div>
                                                                           <h4>{resourcesText}</h4>
                                                                           <img src={resourceSubLogo} className='w-100' />
                                                                       </div>
                                                                   </div>
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </li>
                                                     <li class="nav-item dropdown dropdown-hover position-static">
                                                       <Link class="nav-link dropdown-toggle" to='/' >
                                                           Company <i class="ms-2 arrow down" style={{ marginTop: '-4px' }}></i>
                                                       </Link>
                                                       <div class="dropdown-menu w-100 mt-0" aria-labelledby="navbarDropdown" >
                                  
          
                                                           <div class="container">
                                                               <div class="row my-4">
                                                                   <div class="col-md-6 col-lg-4 mb-3 mb-lg-0">
                                                                       <div class="list-group list-group-flush">
          
                                                                           <Link className="list-group-item list-group-item-action" onMouseEnter={(e)=> onHoverCompany(e, 'CAU')} to="/about">About Us</Link>
                                                                             <Link className="list-group-item list-group-item-action" onMouseEnter={(e)=> onHoverCompany(e, 'CME')} to="/meet-expert">Leadership Team</Link>
                                                                       </div>
                                                                   </div>
                                                                   <div class="col-md-6 col-lg-8 mb-3 mb-lg-0">
                                                                       <div>
                                                                           <h4>{companyText}</h4>
                                                                           <img src={companySubLogo} className='w-100' />                                                                  
                                                                       </div>
                                                                   </div>
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </li>
                                                   <li>
                                                         <Link to="/contact" className="nav-link">Contact Us</Link>
                                                     </li>
                                               </ul>
                                           </div>
                                       </div>
                                   </nav>
          
                                
                              
                           </Col>
                       </Row>
                  
                   </header>
                   </div>
          
                   {
                     openSideBar ?
                           <div className='sidebar inter-normal'>
                               <div className='sidebar-box' >
                                   <ul>
                                       <li>
                                           <Link onClick={handleClickClose} to="/">Home</Link>
                                       </li>
                                       <li id='platformSubMenu' onClick={()=>handleSubMenu('Platforms')}>
                                           <Link to="/">Platforms <i class="bi bi bi-chevron-down me-2 float-end fw-bolder"></i></Link>
                                       </li>
                                       {
                                         openPlatformSubMenu ?
                                         <ul className='ms-3'>
                                         <li><Link onClick={handleClickClose} to="/compliance-engine">Network Compliance Platform</Link></li>
                                         <li><Link onClick={handleClickClose}  to="/bullseye">BullsEye</Link></li>
                                         <li><Link onClick={handleClickClose}  to="/observer">The Observer</Link></li>
                                         <li><Link  onClick={handleClickClose} to="/vAutomate">vAutomate</Link></li>
                                         </ul>
                                         : null
                                       }
                                       <li>
                                           <Link onClick={handleClickClose} to="/services">Services</Link>
                                       </li>
                                       <li id='solutionSubMenu' onClick={()=>handleSubMenu('Solutions')}>
                                           <Link to="/">Resources <i class="bi bi bi-chevron-down me-2 float-end fw-bolder"></i></Link>
                                       </li>
                                       {
                                         openSolutionsSubMenu ?
                                         <ul className='ms-3'>
                                         <li><Link onClick={handleClickClose} to="/brochure">Brochures & Data Sheets</Link></li>
                                         <li><Link  onClick={handleClickClose} to="/successstories">Success Stories</Link></li>
                                         </ul>
                                         : null
                                       }
                                      
                                       {/* //meet-expert */}
                                       <li id='companySubMenu' onClick={()=>handleSubMenu('Company')}>
                                           <Link to="/">Company <i class="bi bi bi-chevron-down me-2 float-end fw-bolder"></i></Link>
                                       </li>
                                       {
                                         openCompanySubMenu ?
                                         <ul className='ms-3'>
                                             <li><Link onClick={handleClickClose} to="/about">About Us</Link></li>
                                             <li><Link onClick={handleClickClose} to="/meet-expert">Leadership Team</Link></li>
                                         </ul>
                                         : null
                                       }
                                       <li>
                                           <Link onClick={handleClickClose} to="/contact">Contact Us</Link>
                                       </li>
                                   </ul>
                               </div>
                           </div>
                     : null
                   }
          
                    
                 <ScrollToTop smooth color="#0d6efd" />
             </>
            
           )
    }
 
  
}